export default __webpack_public_path__ + "locales/ja-JP/VersionHistory.json?hash=10ba1890e2e627005ed39ef81044e17b";